import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import InfoRow from '../../common/InfoRow';
import { ConflictedDhcpReservationDataType } from '../../../../types/types';
import dialogStyles from '../../common/dialogStyles';
import pageStyles from '../../../pages/pageStyles';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ErrorIcon from '@mui/icons-material/Error';
import { red } from '@mui/material/colors';

interface ReservationConflictFormProps {
  errorText: string;
  conflictedReservation: ConflictedDhcpReservationDataType | null;
}

const ReservationConflictForm: React.FC<ReservationConflictFormProps> = ({
  errorText,
  conflictedReservation,
}) => {
  if (!conflictedReservation) {
    return (
      <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
        <InfoOutlinedIcon fontSize="medium" color="warning" />
        Not found data about reservation conflict, please reload the page.
      </Typography>
    );
  }

  return (
    <>
      <ErrorIcon sx={{ fontSize: 50, color: red[500], marginTop: 1 }} />
      <Typography variant="body1">Oops! We couldn't process your request.</Typography>
      {errorText && (
        <Typography variant="body1" sx={{ color: red[500], fontWeight: 'bold', margin: 1 }}>
          Error: {errorText}
        </Typography>
      )}
      <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
        If you need this reservation reassigned, you may do so via the button below. Please note
        that this action will remove the existing reservation and create a new one.
      </Typography>
      <Box
        sx={{
          ...dialogStyles.gridStyles,
          gridTemplateColumns: '1fr',
        }}
      >
        <InfoRow label="Conflicting host:" value={conflictedReservation.host} />
        <InfoRow label="Conflicting IP:" value={conflictedReservation.ip} />
        <InfoRow label="Conflicting MAC:" value={conflictedReservation.mac} />
      </Box>
    </>
  );
};

export default ReservationConflictForm;
